import React, { useMemo } from 'react';
import { Divider, Flex, Typography } from '@banhala/ui-kit';
import { useGoodsLegalNotice } from '../queries/useGoodsLegalNotice';
import { isNil, isNotNil } from 'shared/src/utils';

export const DefaultInformation: React.FC = () => {
  const { data: goodsLegalNotice } = useGoodsLegalNotice();

  const tableList = useMemo(() => {
    const list: { title: string; label: string }[] = [];

    if (isNil(goodsLegalNotice)) return [];

    if (isNotNil(goodsLegalNotice.model_fitting)) {
      list.push({ title: '모델 피팅', label: goodsLegalNotice.model_fitting });
    }

    if (isNotNil(goodsLegalNotice.fabric)) {
      list.push({ title: '소재', label: goodsLegalNotice.fabric });
    }
    if (isNotNil(goodsLegalNotice.color_md)) {
      list.push({ title: '색상', label: goodsLegalNotice.color_md });
    }
    if (isNotNil(goodsLegalNotice.prd_size)) {
      list.push({ title: '사이즈', label: goodsLegalNotice.prd_size });
    }

    return list;
  }, [goodsLegalNotice]);

  return (
    <Flex>
      <Flex padding={{ horizontal: 16 }}>
        <Divider size="small" />
        {tableList.map(item => (
          <Flex key={item.title}>
            <Flex.Row alignItems={'center'} padding={{ vertical: 24 }}>
              <Flex flex={1}>
                <Typography type={'subtitle2'} color={'content_tertiary'}>
                  {item.title}
                </Typography>
              </Flex>
              <Flex flex={4}>
                <Typography type={'body2'} color={'content_secondary'}>
                  {item.label}
                </Typography>
              </Flex>
            </Flex.Row>
            <Divider size="small" />
          </Flex>
        ))}

        <Flex gap={8} padding={{ top: 12, bottom: 12 }}>
          <Typography type={'body4'} color={'content_tertiary'}>
            상세 사이즈는 측정 방법과 위치, 소재에 따라 1~3cm오차가 발생될 수
            있습니다.
          </Typography>
          <Typography type={'body4'} color={'content_tertiary'}>
            제품 컬러는 모니터 해상도와 각도에 따라 다르게 보일 수 있습니다.
          </Typography>
          <Typography type={'body4'} color={'content_tertiary'}>
            아이보리, 화이트 계열의 색상의 경우 비침이 있을수도 있습니다.
          </Typography>
          <Typography type={'body4'} color={'content_tertiary'}>
            모델컷보다 디테일컷이 실제 상품 색상에 가깝습니다.
          </Typography>
          <Typography type={'body4'} color={'content_tertiary'}>
            사이즈는 단면(cm) 측정입니다.
          </Typography>
        </Flex>
      </Flex>
    </Flex>
  );
};
